"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _utils = require("./utils");

var _defaultAtoms = require("./default-atoms");

require("./rule.css");

var offsetIndent = 25;
(0, _defaultAtoms.registerDefaultTypes)(); // values should be a list of id/value pairs. If the id doesn't match, we invalidated it.
// to find the rules, we start at the first rule and iterate through them, looking for next
// based upon whatever is chosen.
// ...that's it. If the user chooses a rule, we re-calculate the rules displayed and carry on.
// but...sometimes we advance to next based on a selected value and sometimes we advance to next
// no matter what.

var saveChosen = function saveChosen(idx, atom, rule, setValues, ruleBook, processors, parentValues) {
  return function (unprocessedValue) {
    var updatedRule = (0, _utils.updateRule)({
      idx: idx,
      atom: atom,
      rule: rule,
      unprocessedValue: unprocessedValue,
      ruleBook: ruleBook,
      processors: processors,
      parentValues: parentValues
    });
    setValues(updatedRule);
  };
};

function makeSubRuleSetter(i, rule, setValues) {
  return function (value) {
    var newSubRules = (0, _toConsumableArray2.default)(rule.subRules);
    newSubRules[i] = value;
    setValues((0, _objectSpread2.default)((0, _objectSpread2.default)({}, rule), {}, {
      subRules: newSubRules
    }));
  };
}

function addSubRule(subRuleId, subRuleType, rule, setValues, ruleBook, processors) {
  var subRule = (0, _utils.newRule)({
    rule: ruleBook[subRuleId],
    ruleBook: ruleBook,
    processors: processors
  });
  var updatedRule = {
    values: rule.values,
    subRuleType: subRuleType,
    subRules: [].concat((0, _toConsumableArray2.default)(rule.subRules), [subRule])
  };
  setValues(updatedRule);
}

function removeSubRule(i, rule, setValues) {
  var newRules = (0, _toConsumableArray2.default)(rule.subRules);
  newRules.splice(i, 1);
  var newRule = {
    values: rule.values,
    subRules: newRules
  };

  if (newRule.subRules.length) {
    newRule.subRuleType = rule.subRuleType;
  }

  setValues(newRule);
}

var Rule = function Rule(_ref) {
  var ruleBook = _ref.ruleBook,
      processors = _ref.processors,
      _ref$rule = _ref.rule,
      rule = _ref$rule === void 0 ? {} : _ref$rule,
      setValues = _ref.setValues,
      removeRule = _ref.removeRule,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 0 : _ref$offset,
      _ref$canDelete = _ref.canDelete,
      canDelete = _ref$canDelete === void 0 ? true : _ref$canDelete,
      parentValues = _ref.parentValues;

  var _getAtoms = (0, _utils.getAtoms)({
    ruleBook: ruleBook,
    values: rule.values,
    processors: processors,
    parentValues: parentValues
  }),
      atoms = _getAtoms.atoms,
      subRuleId = _getAtoms.subRuleId,
      subRuleType = _getAtoms.subRuleType,
      values = _getAtoms.values,
      requiredSubRule = _getAtoms.requiredSubRule,
      singleSubRule = _getAtoms.singleSubRule;
  /*console.log(
    "RENDERS : ",
    rule,
    subRuleType,
    rule.subRules.length,
    singleSubRule,
    !singleSubRule || rule.subRules.length === 1
  );*/


  return /*#__PURE__*/_react.default.createElement("div", {
    className: "rule-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "rule-container",
    style: {
      paddingLeft: "".concat(offset, "px")
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "rule"
  }, atoms.map(function (atom, i) {
    var value = (0, _utils.getValue)(i, atom, values) || {};
    var Component = (0, _utils.getComponent)(atom.type);
    return /*#__PURE__*/_react.default.createElement(Component, {
      key: i,
      atom: atom,
      value: value.value,
      setValue: saveChosen(i, atom, rule, setValues, ruleBook, processors, parentValues)
    });
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "rule-buttons"
  }, canDelete && /*#__PURE__*/_react.default.createElement(_antd.Button, {
    shape: "circle",
    icon: /*#__PURE__*/_react.default.createElement(_icons.MinusOutlined, null),
    label: "Remove rule",
    onClick: removeRule
  }), Boolean(subRuleId) && /*#__PURE__*/_react.default.createElement(_antd.Button, {
    shape: "circle",
    icon: /*#__PURE__*/_react.default.createElement(_icons.PlusOutlined, null),
    label: "Add sub rule",
    disabled: singleSubRule && rule.subRules.length >= 1,
    onClick: function onClick() {
      return addSubRule(subRuleId, subRuleType, rule, setValues, ruleBook, processors);
    }
  }))), rule.subRules.map(function (subRule, i) {
    return /*#__PURE__*/_react.default.createElement(Rule, {
      key: i,
      ruleBook: ruleBook,
      processors: processors,
      rule: subRule,
      setValues: makeSubRuleSetter(i, rule, setValues),
      removeRule: function removeRule() {
        return removeSubRule(i, rule, setValues);
      },
      offset: offset + offsetIndent,
      canDelete: !requiredSubRule || rule.subRules.length > 1,
      parentValues: {
        values: values,
        parentValues: parentValues
      }
    });
  }));
};

var _default = Rule;
exports.default = _default;